const isAffectingAccountDescResolver = (pharmacyGroupName, hasSuspendedAffectingAccount) => {
  if (hasSuspendedAffectingAccount) {
    return "Due to insufficient claims at this account, other account(s) are Suspended. To gain access, submit claims at this account to validate purchases.";
  }

  return "Due to insufficient claims at this account, other account(s) are At Risk. To avoid suspension and maintain access to pricing, submit claims at this account to validate purchases.";
};

export const HORIZON = {
  STATUS_NAME: {
    eligible: "Eligible",
    at_risk: "At Risk",
    suspended: "Suspended",
  },

  STATUS_BADGE_COLOR: {
    eligible: "green",
    suspended: "red",
    at_risk: "orange",
  },

  STATUS_DESC: {
    suspended: "Accounts that have lost access to pricing. Submit claims to regain access.",
    at_risk:
      "Accounts that are at risk of losing pricing. Submit claims in order to maintain access to pricing.",
    eligible:
      "All pharmacies in this account are eligible for 340B pricing. Keep submitting claims to validate purchases and maintain access to pricing.",
  },

  ACCOUNT_DESC: {
    eligible: {
      default: () => "Submit claims to validate purchases.",
      is_affected: () => "", // this shouldn't be possible.
      is_affecting: isAffectingAccountDescResolver,
    },
    suspended: {
      default: () =>
        "All pharmacies in this account are considered Suspended. Insufficient claims have been submitted to validate purchases. To gain access, submit claims to validate purchases.",
      is_affected: (pharmacyGroupName) =>
        `All pharmacies in this account are considered Suspended. Insufficient claims have been submitted to validate purchases at ${pharmacyGroupName} which has impacted this account. To gain access, submit claims at ${pharmacyGroupName} to validate purchases.`,
      is_affecting: isAffectingAccountDescResolver,
    },
    at_risk: {
      default: () =>
        "All pharmacies in this account are considered At Risk. Insufficient claims have been submitted to validate purchases. To avoid suspension and maintain access to pricing, submit claims to validate purchases.",
      is_affected: (pharmacyGroupName) =>
        `All pharmacies in this account are considered At Risk. Insufficient claims at ${pharmacyGroupName} has impacted this account. To avoid suspension and maintain access to pricing, submit claims at ${pharmacyGroupName} to validate purchases.`,
      is_affecting: isAffectingAccountDescResolver,
    },
  },

  IDENITIFER_SORT_ORDER: ["dea", "hin", "npi"],
};
